import { render, staticRenderFns } from "./StoryPositions.vue?vue&type=template&id=22d0dde2&scoped=true&"
import script from "./StoryPositions.vue?vue&type=script&lang=js&"
export * from "./StoryPositions.vue?vue&type=script&lang=js&"
import style0 from "./StoryPositions.vue?vue&type=style&index=0&id=22d0dde2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0dde2",
  null
  
)

export default component.exports